import { styled } from "@mui/material/styles";
import { Avatar, Badge, Box, Grid, Select } from "@mui/material";
import { Link } from "react-router-dom";
import Button from "../shared/Button/Button";

export const StyledLogo = styled("img")(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
  width: theme.spacing(25),
  maxHeight: theme.spacing(8)
}));

export const StyledContainer = styled(Grid)(({ theme }) => ({
  background: theme.palette.common.background.main,
  textAlign: "left"
}));

export const StyledDropdown = styled(Select)(({ theme }) => ({
  padding: theme.spacing(1),
  background: theme.palette.common.background.main,
  marginTop: theme.spacing(0)
}));

export const StyledAvatarButton = styled(Button)(({ theme }) => ({}));

export const StyledButton = styled(Link, {
  shouldForwardProp: (prop) => prop !== "selectedButton"
  //@ts-ignore
})(({ theme, selectedButton }) => ({
  background: selectedButton === true ? "#ff9800" : theme.palette.primary.light,
  color: "white",
  textDecoration: "none",
  height: theme.spacing(4),
  width: theme.spacing(12),
  border: `solid 1px ${
    selectedButton === true ? "#ff9800" : theme.palette.primary.light
  }`,
  margin: theme.spacing(1),
  padding: theme.spacing(1),
  "&:hover": {
    cursor: "pointer"
  }
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  padding: theme.spacing(0.5)
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  marginTop: theme.spacing(6),
  height: theme.spacing(8),
  width: theme.spacing(8)
}));

export const AvatarBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1)
}));
export default {
  StyledButton,
  StyledDropdown,
  StyledLogo,
  StyledContainer,
  StyledBadge,
  StyledAvatar,
  StyledAvatarButton,
  AvatarBox
};
